import {
  Action,
  ActionType,
  IConfirmStudentListResponse,
} from "models/classchangemanagement/confirmStudentListClassChange";
import createReducer from "../../createReducer";

export interface ConfirmStudentListReducerType {
  loading: boolean;
  error?: string;
  confirmStudentListResponse?: IConfirmStudentListResponse;
}

const defaultState: ConfirmStudentListReducerType = {
  loading: false,
  error: undefined,
  confirmStudentListResponse: undefined,
};

export const getConfirmStudentListReducer =
  createReducer<ConfirmStudentListReducerType>(defaultState, {
    [ActionType.CONFIRM_STUDENT_LIST](state: ConfirmStudentListReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.CONFIRM_STUDENT_LIST_ERROR](
      state: ConfirmStudentListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.CONFIRM_STUDENT_LIST_SUCCESS](
      state: ConfirmStudentListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        confirmStudentListResponse: action.payload,
      };
    },

    [ActionType.CONFIRM_STUDENT_LIST_RESET](
      state: ConfirmStudentListReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        confirmStudentListResponse: [],
      };
    },
  });
